module.exports = __webpack_public_path__ + "img/commands-empty-state.b9a976c4.svg";